import { useEffect, useMemo, useState } from "react";
import { ReactComponent as IconClose } from "../../../../assets/icons/view-similar-close.svg";
import "./index.scss";
import { getViewSimilar } from "../../../../utils/ctRecommendation";
import { CustomModal } from "../../elements/customModal";
import { setViewSimilarFailure } from "../../../../store/application";
import { useDispatch } from "react-redux";
import i18n from "../../../../utils/translations/i18n";

const ViewSimilarModal = ({ isViewSimilarOpen, setIsViewSimilarOpen, closeModal, lineItemId, webCode, isMobile, containerRef, containerId }) => {
  const dispatch = useDispatch();
  const { t } = i18n;
  const [showModal,setShowModal] = useState(false);

  useEffect(() => {
    const colSize = isMobile ? 2 : 3;
    getViewSimilar(webCode, "Cart Page", colSize, containerId,lineItemId);
  }, [isMobile, webCode, containerId]);

  const checkModalVisibility = () => {
    const targetDiv = containerRef.current.querySelector(".ct-placement-products") as HTMLDivElement | null;
    if (!targetDiv) return;
    const hasSlickClass = targetDiv.classList.contains("slick-initialized");
    const hasChildren = targetDiv.children.length > 1;
    setShowModal((hasSlickClass && hasChildren))
    setIsViewSimilarOpen((hasSlickClass && hasChildren))
    dispatch(setViewSimilarFailure(!(hasSlickClass && hasChildren)));
  }

  useEffect(() => {
    if(isViewSimilarOpen){
      checkModalVisibility();
    }else{
      dispatch(setViewSimilarFailure(false));
      setShowModal(false)
    }
  },[isViewSimilarOpen])

  const viewSimilarHeader = (
    <div className="view-similar-parent">
      <div className="view-similar-header">
        <div className="similar-products" data-testid="similar-products">{t('oos.similar_products')}</div>
        <div className="vs-icon-cancel" onClick={closeModal}>
          <IconClose className="close-icon" />
        </div>
      </div>
    </div>
  );
  
  const viewSimilarBody = (
    <div id="view-similar-ct-recs">
      <div
        ref={containerRef}
        className="vs-ct-placement-container ct-placement-container padding-right cart-page-placement-container"
        id={containerId}
        data-testid="view-similar-container"
      >
        <div className="carousel-products ct-placement-products pdi-tracker-element"></div>
      </div>
    </div>
  );

  return (
    <CustomModal isOpen={showModal && isViewSimilarOpen} closeModal={closeModal}>
      <div className="view-similar-content">
        {viewSimilarHeader}
        {viewSimilarBody}
      </div>
    </CustomModal>
  );
};

export default ViewSimilarModal;
